export const carouselConfigWeb = {
  infinite: false,
  slidesToScroll: 6,
  slidesToShow: 6,
  arrows: true,
  dots: false,
  autoplay: false,
  centerMode: false,
  touchMove: false,
};

export const carouselConfigMobile = {
  infinite: false,
  arrows: true,
  dots: false,
  autoplay: false,
  centerMode: false,
  touchMove: false,
  slidesToShow: 2,
  slidesToScroll: 2,
  swipeToSlide: false,
};
